<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>International FIDE Rapid Rating Chess Tournament Pune</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>International FIDE Rapid Rating Chess Tournament Pune</span></h2>
        </div>

        <p><strong>4th G H Raisoni Memorial Pune International FIDE Rapid Rating Chess Tournament 2026 Concludes
                Successfully</strong>
        </p>
        <p> The 4th G H Raisoni Memorial Pune International FIDE Rapid Rating Chess Tournament 2026 was successfully
            held on
            5th July 2026 at G H Raisoni College of Engineering & Management, Wagholi, Pune. The prestigious FIDE-rated
            event brought together talented chess players from across the country, providing a competitive platform for
            players across various rating categories.

        </p>
        <p> The tournament was inaugurated by Dr. Nagnath Hulle, Director of G H Raisoni College of Engineering &
            Management, Wagholi, Pune, while Grandmaster Laxman R. R. graced the occasion as the Guest of Honour. The
            event
            was conducted smoothly under the supervision of Chief Arbiter Ajinkya Pingale and his experienced arbiter
            team,
            strictly following FIDE, AICF and Maharashtra Chess Association (MCA) regulations.
        </p>
        <p> The championship witnessed remarkable performances, with Jaiveer Mahendru emerging as the winner with 8½
            points,
            followed by Gaikwad Manas in second place and Avirat Chauhan in third. The prize distribution ceremony was
            graced by Rajendra Konde, Vice President, Maharashtra Chess Association, and IA Nitin Shenvi, Rating
            Officer,
            All India Chess Federation (AICF).

        </p>
        <p> The tournament concluded successfully with excellent coordination among the organizing committee, arbiters,
            volunteers and technical staff. The overwhelming response from participants and the smooth conduct of the
            event
            further strengthened the reputation of the G H Raisoni Memorial Pune International FIDE Rapid Rating Chess
            Tournament as one of Maharashtra's leading FIDE-rated rapid chess events.</p>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>
                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/events/raisoni-pune-report.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Prize List</h4>
                            </div>
                        </div>
                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/events/rapid-rating-ghraisoni-prize-list.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
